module.exports = "/virtual-football-league/img/amblems/left/logos/FakeNorwichCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeNorwichCity.png
// module id = 2072
// module chunks = 4